import { contextFactory } from '../../../hooks/context-factory';
import type { DynamicFieldAttributes, SharedDynamicFieldsProps } from '../molecules/dynamic-field-action';

interface EditorContext {
  readOnly?: boolean;
  markdownContent?: string;
  dynamicFields?: DynamicFieldAttributes[];
  hasDraggableBlocks?: boolean;
  disableFocusTrap?: boolean;
  sharedDynamicFieldProps?: SharedDynamicFieldsProps;
}

interface EditorProviderProps extends EditorContext {
  children: React.ReactNode;
}

export const [EditorContext, useEditorContext] = contextFactory<EditorContext>();

export const EditorProvider = ({ children, ...providerProps }: EditorProviderProps) => {
  return <EditorContext.Provider value={providerProps}>{children}</EditorContext.Provider>;
};
